import React from "react";
import styles from "./style.module.scss";
import { observer } from "mobx-react";
import { observable } from "mobx";
import UserInfo from "../../store/userInfo";
import { MUTATE } from "../../utilities/network";
import { RouteComponentProps } from "react-router";
import { Icon, Form, Input, Button, Modal } from "antd";
import TopBar from "../../components/topBar";

@observer
export default class LoginPage extends React.Component<RouteComponentProps<{}>> {
  emailInput = "";
  passwordInput = "";
  @observable emailInputStatus: "error" | undefined;
  @observable passwordInputStatus: "error" | undefined;

  render() {
    const mailIcon = <Icon type="user" className={styles.icon} />;
    const passwordIcon = <Icon type="lock" className={styles.icon} />;

    return (
      <div className={styles.container}>
        <TopBar />
        <div className={styles.title}>
          Grow your organization with real-time
          <br />
          strategic leadership data.
        </div>

        <div className={styles.white_board}>
          <div className={styles.welcome_box}>
            <span className={styles.yomento_logo} />
            <span>Welcome!</span>
          </div>

          <div className={styles.input_box}>
            <Form.Item validateStatus={this.emailInputStatus}>
              <Input
                prefix={mailIcon}
                placeholder="Email"
                size="large"
                onChange={this._onEmailChange}
              />
            </Form.Item>
            <Form.Item validateStatus={this.passwordInputStatus}>
              <Input.Password
                prefix={passwordIcon}
                placeholder="Password min. 6 characters"
                size="large"
                onChange={this._onPasswordChange}
              />
            </Form.Item>

            <a className={styles.forget_password} href="mailto:support@yomento.com">
              Forgot your password?
            </a>

            <Button type="primary" size="large" onClick={this._onClickLogin}>
              LOG IN
            </Button>
          </div>
        </div>
      </div>
    );
  }

  _onEmailChange = (e: any) => {
    this.emailInput = e.nativeEvent.target.value;
  };

  _onPasswordChange = (e: any) => {
    this.passwordInput = e.nativeEvent.target.value;
  };

  _onClickLogin = async () => {
    this.emailInputStatus = this._validateEmail(this.emailInput) ? undefined : "error";
    this.passwordInputStatus = this.passwordInput.length < 6 ? "error" : undefined;

    if (this.emailInputStatus !== "error" && this.passwordInputStatus !== "error") {
      try {
        const params = {
          email: this.emailInput,
          pwd: this.passwordInput,
        };
        const res = await MUTATE<{ token: string }>(LOGIN_ACTION, params);
        console.log({ res });

        UserInfo.setTokenAndAccount(res.token, this.emailInput);

        this.props.history.push("/admin/home");
      } catch (e) {
        Modal.error({
          title: e.message,
          okText: "Try again later",
        });
      }
    }
  };

  _validateEmail = (email: string): boolean => {
    const re =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  };
}

const LOGIN_ACTION = `
mutation($email: EmailAddress!, $pwd: String!) {
  token: adminLogin(pwd: $pwd, email: $email)
}`;
